<template>
  <div :class="{'shorttag-update-btn': btnType === 'update'}">
    <button
      class="btn btn-light"
      type="button"
      @click="openModal"
    >
      <template v-if="btnType === 'update'">
        FAQ {{ $t('tiptap:btn.edit') }}
      </template>
      <template v-else>
        FAQs
      </template>
    </button>
    <modal
      :name="modalName"
      :scrollable="true"
      :draggable="true"
      height="auto"
      width="800px"
      @close="closeModal"
    >
      <button
        class="modal-close"
        type="button"
        @click="closeModal"
      >
        <i class="icon">
          <icon-times />
        </i>
      </button>
      <div class="modal-header">
        <h2 class="text-center mb-4">
          FAQ List
        </h2>
      </div>
      <div class="modal-body m-4">
        <div class="container">
          <div class="input-group mb-2">
            <span class="input-group-prepend">
              <span class="input-group-text">
                <i
                  v-b-tooltip.hover
                  class="icon "
                  title="Optionale Überschrift für eine FAQ List (ohne Schema Markup)"
                >
                  <icon-info-circle />
                </i>
              </span>
            </span>
            <b-form-input
              v-model="header"
              placeholder="Titel"
              type="text"
            />
          </div>
          <b-input-group>
            <span class="input-group-prepend">
              <span class="input-group-text">
                <i
                  v-b-tooltip.hover
                  class="icon "
                  title="Optionaler Einleitungtext für eine FAQ Liste"
                >
                  <icon-info-circle />
                </i>
              </span>
            </span>
            <b-form-input
              v-model="description"
              placeholder="Einleitung / Beschreibung"
              type="text"
            />
          </b-input-group>

          <!-- Elements List -->
          <h5>
            FAQ Frage / Antwort Elemente. Schema Markup wird hinzugefügt
          </h5>
          <div
            v-for="(item,itemIndex) in elements"
            :key="itemIndex"
          >
            <div class="form-group">
              <div class="input-group">
                <b-form-input
                  v-model="elements[itemIndex].question"
                  type="text"
                />
                <div class="input-group-append">
                  <span
                    class="input-group-text"
                    @click="prepareDel(itemIndex)"
                    @keypress="prepareDel(itemIndex)"
                  >
                    <i
                      v-b-tooltip.hover
                      title="Frage entfernen"
                      class="icon icon-danger"
                    >
                      <icon-times-circle />
                    </i>
                  </span>
                </div>
              </div>
              <div :class="{hide:delItems.indexOf('item_'+itemIndex) === -1}">
                <button
                  class="mr-2 mt-2 btn btn-small btn-danger"
                  type="button"
                  @click.prevent="delItem(itemIndex,false)"
                >
                  Frage/Antwort engültig entfernen!
                </button>
                <button
                  type="button"
                  class=" mt-2 btn btn-small btn-secondary"
                  @click.prevent="delItem(itemIndex,true)"
                >
                  Abbrechen
                </button>
              </div>
            </div>
            <div class="form-group">
              <div class="input-group">
                <b-form-textarea
                  v-model="elements[itemIndex].answer"
                  rows="3"
                  max-rows="6"
                />
                <div class="input-group-append">
                  <span class="input-group-text">
                    <button
                      class="btn btn-secondary btn-small"
                      :class="{collapsed:elements[itemIndex].itemCollapsible}"
                      type="button"
                      @click.prevent="elements[itemIndex].itemCollapsible = !elements[itemIndex].itemCollapsible"
                    >
                      <span v-show="elements[itemIndex].itemCollapsible">collapsed</span>
                      <span v-show="!elements[itemIndex].itemCollapsible">expanded</span>
                    </button>
                  </span>
                </div>
              </div>
            </div>
          </div>

          <!-- Buttons -->
          <b-button
            class="btn btn-secondary mr-2"
            @click.prevent="emitData(btnType)"
          >
            {{ $t('tiptap:btn.ok') }}
          </b-button>
          <b-button
            class="btn btn-secondary mr-2"
            @click.prevent="addEntry()"
          >
            <i
              v-b-tooltip.hover
              class="icon"
              title="Weitere Frage/Antwort Gruppe einfügen "
            >
              <icon-plus />
            </i>
          </b-button>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
/** Bootstrap VUE */
import {
  BFormInput, BButton, BFormTextarea, VBTooltip, BInputGroup
} from 'bootstrap-vue';
import 'scss/bootstrap/vue/components/tooltip.scss';

/** ICON imports */
import IconTimes from 'ICON:IconTimes';
import IconTimesCircle from 'ICON:IconTimesCircleAlternative';
import IconInfoCircle from 'ICON:IconInfoCircle';
import IconPlus from 'ICON:IconPlus';



export default ({
  name: 'FaqListBtn',
  components: {
    BFormInput,
    BButton,
    BFormTextarea,
    IconTimes,
    IconTimesCircle,
    IconInfoCircle,
    BInputGroup,
    IconPlus
  },
  directives: { 'b-tooltip': VBTooltip },
  props: {
    // button can insert new or update existing shorttag
    btnType: {
      type: String,
      default: 'insert',
    },
    headerProp: {
      type: String,
      default: '',
    },
    descriptionProp: {
      type: String,
      default: '',
    },
    elementsProp: {
      type: [Array, Boolean],
      default: false
    },

  },
  data() {
    return {
      // modal name has to be unique
      modalName: `faqListBtnModal_${this.btnType}_${Math.floor(Math.random() * 1000)}`,
      header: '',
      description: '',
      elements: [{ question: 'Frage 1', answer: 'Antwort 1', itemCollapsible: true }],
      defaultItem: { question: 'Frage ...', answer: 'Antwort ...', itemCollapsible: true },
      delItems: [],
    };
  },
  methods: {
    closeModal() {
      this.description = '';
      this.header = '';
      this.elements = [
        { ...this.defaultItem },
      ];
      this.$modal.hide(this.modalName);
    },
    emitData() {
      this.$emit(`${this.btnType}-content`, {
        type: 'FaqListShorttag',
        attrs: {
          listHeader: this.header,
          listDescription: this.description,
          listElements: this.elements,
        },
      });
      this.closeModal();
    },
    openModal() {
      this.header = window.getSelection().toString();
      if (!this.header) {
        this.header = this.headerProp ? this.headerProp : '';
      }
      this.description = this.descriptionProp ? this.descriptionProp : '';

      if (this.elementsProp.length) {
        this.elements = this.elementsProp;
      }

      this.$modal.show(this.modalName);
    },
    addEntry() {
      this.elements.push({ ...this.defaultItem });
    },
    delItem(itemIndex, cancel) {
      this.delItems = this.delItems.filter((val) => val === itemIndex);// remove item from del queue
      this.elements[itemIndex].markForDelete = true; // set property for filter usage at this index position
      if (!cancel) { // remove item question/answer from list
        delete this.elements[itemIndex];
        this.elements = this.elements.filter((item) => !item.markForDelete); // get all except the marked
      }
    },
    prepareDel(itemIndex) {
      this.delItems.push(`item_${itemIndex}`);
    }
  },
});
</script>
